import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7786effe&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7786effe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLogo: require('/opt/airport.kg/src/components/base/logo.vue').default,BaseHeaderAirportSelect: require('/opt/airport.kg/src/components/base/header/airport-select.vue').default,BaseHeaderInfo: require('/opt/airport.kg/src/components/base/header/info.vue').default,BaseHeaderSearch: require('/opt/airport.kg/src/components/base/header/search.vue').default,BaseHeaderLangSwitcher: require('/opt/airport.kg/src/components/base/header/lang-switcher.vue').default,RzIconBurger: require('/opt/airport.kg/node_modules/razlet-ui/src/icons/icon-burger/index.vue').default,BaseHeaderDrawer: require('/opt/airport.kg/src/components/base/header/drawer/index.vue').default})
